<template>
  <div id="app">
    <b-container fluid>
      <Ribbon text='E-T-A Customs Modules' url='https://customs.tabieta.net/' color='#0496d0' fixed />
      <div class="wrapper">
        <router-view/>
      </div>
    </b-container>
    <div class="wave-wrapper2">
        <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
            <defs>
                <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
            </defs>
            <g class="parallax">
                <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.1" />
                <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.075)" />
                <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.125)" />
                <use xlink:href="#gentle-wave" x="48" y="7" fill="rgba(255,255,255,0.05)" />
            </g>
        </svg>
    </div>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/css/styles.css'

import Ribbon from 'vue-ribbon'

export default {
  name: 'App',
  components: {
    Ribbon
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue